import range from 'lodash/range'
import { useObserver } from 'mobx-react-lite'
import React, { FC, useLayoutEffect, useRef } from 'react'
import {
  INDIVIDUAL_SEPARATOR_IDENTIFIER,
  PAGE_SEPARATOR_IDENTIFIER
} from '../../constants'
import useItemContext from '../../hooks/use-item-context'
import * as css from './GroupedItems.css'

export interface GroupedItemsProps {
  id: string
  itemRenderer: any
  node: any
}

export const GroupedItems: FC<GroupedItemsProps> = ({ id, itemRenderer, node }) => {
  return useObserver(function useHook() {
    const [groupId, startIndex, endIndex] = id.split(PAGE_SEPARATOR_IDENTIFIER)
    const ref = useRef<HTMLDivElement>()
    const {
      store: { resizeObserver }
    } = useItemContext()
    // const initialHeight = useMemo(() => node.height, [id])
    useLayoutEffect(() => {
      const ele = ref.current
      if (ref.current) {
        resizeObserver.observe(ref.current.firstChild)
      }
      return () => resizeObserver.unobserve(ele.firstChild)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref.current])
    return (
      <div ref={ref} className={css['grouped-items-container']}>
        {range(+startIndex, +endIndex + 1).map(i =>
          itemRenderer({
            id: `${groupId}${INDIVIDUAL_SEPARATOR_IDENTIFIER}${i}`,
            node,
            observe: false
          })
        )}
      </div>
    )
  })
}
